import React from "react";
import {
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  makeStyles
} from "@material-ui/core";
import { ThemeType } from "@theme";
import { AccommodationSelectorValueProps, Props } from "./utils";
import { AccommodationSelectorValue } from "./AccommodationSelectorValue";

type AccommodationSelectorControlProps = Props & {
  onOpen: () => void;
};

export function AccommodationSelectorControl(props: AccommodationSelectorControlProps) {
  const classes = useStyles({});

  if (props.invisible) {
    return null;
  }

  const label = props.error || props.label || "";
  const isEmpty = !props.value?.accommodationId;

  const inputProps: AccommodationSelectorValueProps = {
    disabled: props.disabled,
    clearable: props.clearable,
    value: props.value,
    onClear: () => props.onChange(null),
    onOpen: props.onOpen
  };

  // MUI's Input forwards clicks through several wrappers (root, focus
  // forwarders) and into the inputComponent. Blocking onClick on the empty-
  // state div alone leaves those wrappers clickable, so cancel the click at
  // capture-time on the FormControl when disabled.
  const blockClicks = props.disabled
    ? (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
      }
    : undefined;

  return (
    <FormControl
      disabled={props.disabled}
      error={Boolean(props.error)}
      fullWidth={props.fullWidth}
      required={props.required}
      onClickCapture={blockClicks}
    >
      <InputLabel shrink={!isEmpty}>{label}</InputLabel>

      <Input
        classes={{
          root: classes.inputRoot
        }}
        disableUnderline={!isEmpty}
        error={Boolean(props.error)}
        inputComponent={AccommodationSelectorValue}
        inputProps={inputProps}
        value={props.value}
      />

      {props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
    </FormControl>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  inputRoot: {
    cursor: "pointer",

    "&$disabled": {
      cursor: "default",
      pointerEvents: "none"
    }
  }
}));
